import React from "react";
import { RiDeleteBinLine } from "react-icons/ri";
import { TiEdit } from "react-icons/ti";

//import "./bankView";
import "./bankView.css";

function BankTag({ value, item, createEditAddress, deleteAddress, isDisable }) {
  return (
    <div className="form-control">
      <div className="row">
        <div className="input-group">
          <div claclassName="list-type2" style={{ flexGrow: "1" }}>
            <ul style={{ marginBottom: "0px" }}>
              <li>
                <span href="#">{item.nombre}</span>
              </li>
              <li>
                <span href="#">{item.alias}</span>
              </li>
              <li>
                <span href="#">{item.cuenta}</span>
              </li>
            </ul>
          </div>
          {/*  <input
          className="form-control"
          defaultValue="text"
          value={value}
          aria-label="readonly input example"
          readOnly
        />*/}
          <button
            className="btn btn-warning"
            type="button"
            id="button-addon2"
            onClick={(event) => createEditAddress(event, item)}
            disabled={isDisable}
          >
            <TiEdit />
          </button>
          <button
            className="btn btn-danger"
            type="button"
            id="button-addon2"
            onClick={(event) => deleteAddress(event, item)}
            disabled={isDisable}
          >
            <RiDeleteBinLine />
          </button>
        </div>
      </div>
    </div>
  );
}

export default BankTag;
